// extracted by mini-css-extract-plugin
module.exports = {"chatRoomContainer":"Chat_chatRoomContainer__mgiuY"};